import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import "@arco-design/web-react/es/Radio/style";
import _Radio from "@arco-design/web-react/es/Radio";
import "@arco-design/web-react/es/Checkbox/style";
import _Checkbox from "@arco-design/web-react/es/Checkbox";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import { flowExcelStore } from '@/store/flowExcelStore';
import { replaceFieldName } from '@/utils/formItem';
function toOption(item) {
  if (item.value === undefined || item.value === null || item.text === undefined) {
    return null;
  }
  const uiValue = typeof item.value === 'boolean' ? `__enum_boolean_${item.value ? '1' : '0'}__` : String(item.value);
  return {
    label: item.text,
    value: item.value,
    uiValue,
    disabled: Boolean(item.disabled),
    raw: item
  };
}
function compareOption(a, b) {
  return String(a.label).localeCompare(String(b.label), 'zh-CN');
}
function findOptionByUiValue(options, uiValue) {
  if (Array.isArray(uiValue)) {
    return options.filter(item => uiValue.includes(item.uiValue));
  }
  return options.find(item => item.uiValue === uiValue);
}
function toUiValue(value) {
  if (Array.isArray(value)) {
    return value.map(item => typeof item === 'boolean' ? `__enum_boolean_${item ? '1' : '0'}__` : String(item));
  }
  if (typeof value === 'boolean') {
    return `__enum_boolean_${value ? '1' : '0'}__`;
  }
  return value === undefined || value === null ? undefined : String(value);
}
function EnumSelector(props) {
  const {
    pKey,
    type = 'select',
    name,
    placeholder = '请选择',
    value,
    onChange,
    allowClear = true,
    disabled,
    options,
    defaultValue,
    isMultiple = false,
    bordered = true,
    filterSort = false
  } = props;
  const enumList = useSelector(state => state.dicts?.enumListMap?.[pKey || ''] || []);
  const mergedOptions = useMemo(() => {
    // 外部直接传的 options 可能只含 { label, value }，没有 uiValue / raw，
    // 这里统一补齐，保证 <Select.Option value=...> 和 findOptionByUiValue 都能用。
    const nextOptions = options ? options.map(opt => ({
      ...opt,
      uiValue: opt.uiValue ?? (typeof opt.value === 'boolean' ? `__enum_boolean_${opt.value ? '1' : '0'}__` : String(opt.value)),
      raw: opt.raw ?? {
        value: opt.value,
        text: typeof opt.label === 'string' ? opt.label : String(opt.value)
      }
    })) : enumList.map(toOption).filter(item => Boolean(item));
    return filterSort ? [...nextOptions].sort(compareOption) : nextOptions;
  }, [enumList, filterSort, options]);
  if (type === 'radio') {
    if (isMultiple) {
      return /*#__PURE__*/React.createElement(_Checkbox.Group, {
        value: toUiValue(value),
        defaultValue: toUiValue(defaultValue),
        disabled: disabled,
        onChange: nextValue => {
          const selected = findOptionByUiValue(mergedOptions, nextValue);
          const key = replaceFieldName(name, 'Name');
          flowExcelStore.form?.setFieldValue(key, selected?.label);
          onChange?.(Array.isArray(selected) ? selected.map(item => item.value) : [], selected.raw.data, name, true);
        }
      }, mergedOptions.map(item => /*#__PURE__*/React.createElement(_Checkbox, {
        key: item.uiValue,
        value: item.uiValue,
        disabled: item.disabled
      }, item.label)));
    }
    return /*#__PURE__*/React.createElement(_Radio.Group, {
      value: toUiValue(value),
      defaultValue: toUiValue(defaultValue),
      disabled: disabled,
      onChange: nextValue => {
        const selected = findOptionByUiValue(mergedOptions, nextValue);
        const key = replaceFieldName(name, 'Name');
        flowExcelStore.form?.setFieldValue(key, selected?.label);
        onChange?.(Array.isArray(selected) ? undefined : selected?.value, selected.map(item => item.raw.data), name, true);
      }
    }, mergedOptions.map(item => /*#__PURE__*/React.createElement(_Radio, {
      key: item.uiValue,
      value: item.uiValue,
      disabled: item.disabled
    }, item.label)));
  }
  return /*#__PURE__*/React.createElement(_Select, {
    value: toUiValue(value),
    defaultValue: toUiValue(defaultValue),
    mode: isMultiple ? 'multiple' : undefined,
    disabled: disabled,
    placeholder: placeholder,
    allowClear: allowClear,
    bordered: bordered,
    showSearch: true,
    filterOption: (inputValue, option) => String(option?.props?.children ?? '').toLowerCase().includes(String(inputValue ?? '').toLowerCase()),
    onChange: nextValue => {
      const selected = findOptionByUiValue(mergedOptions, nextValue);
      const key = replaceFieldName(name, 'Name');
      flowExcelStore.form?.setFieldValue(key, selected?.label);
      onChange?.(Array.isArray(selected) ? selected.map(item => item.value) : selected?.value, selected?.raw?.data, name, true);
    }
  }, mergedOptions.map(item => /*#__PURE__*/React.createElement(_Select.Option, {
    key: item.uiValue,
    value: item.uiValue,
    disabled: item.disabled
  }, item.label)));
}
export default EnumSelector;